import { format } from 'date-fns';

import i18n from '../i18n/i18n';

export const dateOrUndefined = (dateString: unknown) => {
  if (!dateString) return undefined;

  if (dateString instanceof Date) return dateString;

  if (typeof dateString !== 'string') return undefined;

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return undefined;

  return date;
};

export const toDateString = (dateString: unknown) => {
  const date = dateOrUndefined(dateString);

  if (!date) return undefined;

  return date.toLocaleDateString('nl-BE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const todayShort = () => format(new Date(), 'yyyy-MM-dd');
export const formatDateTimeLong = (dateString: Maybe<Date | string>) => {
  const date = dateOrUndefined(dateString);
  if (!date) return '';

  const { format } = new Intl.DateTimeFormat(i18n.language, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return format(date);
};

export const isOlderThan12Months = (dateString: unknown): boolean => {
  const date = dateOrUndefined(dateString);

  if (!date) return false;

  const twelveMonthsAgo = new Date();
  twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12);

  return date < twelveMonthsAgo;
};
